module.exports = __webpack_public_path__ + "static/image-03-b@2x-7eb8094798e2641bcfeb0bb6c4b03315.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cookpad/image-03-b@2x.png
// module id = 348
// module chunks = 3627797113349 20562973939449 33019919093843